var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSpin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6669 24.1868C19.9252 23.6297 20.3227 23.1487 20.8211 22.79C22.8138 21.4497 25.4682 22.5795 26.5417 24.5177C28.1189 27.362 26.5003 30.8492 23.6748 32.1877C19.915 33.9736 15.4578 31.8982 13.8241 28.2662C11.7656 23.6943 14.3693 18.4005 18.9187 16.5243C24.4287 14.2534 30.7301 17.3101 32.9014 22.6434C35.458 28.9279 31.8543 36.0546 25.5773 38.4534C18.3302 41.2244 10.1621 37.1751 7.46253 30.1405C4.39829 22.1452 9.00969 13.1762 17.0162 10.2586C25.9984 6.98759 36.037 12.0276 39.2611 20.7673C39.8927 22.4637 40.2585 24.2474 40.3458 26.0554",
    stroke: "currentcolor",
    strokeWidth: 3,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3451 32.9706L36.2124 25.8125H44.4779L40.3451 32.9706Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpin);
export default __webpack_public_path__ + "static/media/Icon_Spin.7769ab7bb2d2110eddd718b6dcd1ce98.svg";
export { ForwardRef as ReactComponent };